@if (formElement?.fieldType === FormFieldType.Select) {
    <ng-container [formGroup]="$any(controlContainer?.control)">
        <wdx-form-field
            [locked]="formElement?.isLocked"
            [legend]="formElement?.label | translateTokenisedString"
            [guidanceText]="
                formElement?.guidanceText | translateTokenisedString
            "
            [isSensitive]="formElement?.isSensitive ?? undefined"
            [isRequired]="formElement?.isRequired ?? undefined"
            [validationErrorMessage]="
                formControl?.touched
                    ? (formControl?.errors | validationErrorMessage)
                    : ''
            "
            [warningMessage]="warningText || ''"
        >
            @if (formElement?.elementStyle === FORM_ELEMENT_STYLE.Checkboxes) {
                @for (
                    option of fieldDefOptions$ | ngrxPush;
                    track option.value
                ) {
                    <wdx-checkbox
                        [label]="option.label || ''"
                        [value]="option.value"
                        [checked]="formControl?.value?.includes(option.value)"
                        [disabled]="
                            isDisabled ||
                            PENDING_CHANGES_LOCK_FIELD.includes(
                                $any(formElement?.pendingChange?.status)
                            )
                        "
                        (isChecked)="onCheckboxChange($event, option.value)"
                    ></wdx-checkbox>
                }
            }

            @if (formElement?.elementStyle === FORM_ELEMENT_STYLE.CheckTiles) {
                <wdx-checkbox-tile-group>
                    @for (
                        option of fieldDefOptions$ | ngrxPush;
                        track option.value
                    ) {
                        <wdx-checkbox-tile
                            [label]="option.label"
                            [value]="option.value"
                            [checked]="
                                formControl?.value?.includes(option.value)
                            "
                            [disabled]="
                                isDisabled ||
                                PENDING_CHANGES_LOCK_FIELD.includes(
                                    $any(formElement?.pendingChange?.status)
                                )
                            "
                            (isChecked)="onCheckboxChange($event, option.value)"
                        >
                            @if (option.iconStack) {
                                <wdx-icon-stack icon>
                                    @for (
                                        icon of option.iconStack;
                                        track $index
                                    ) {
                                        <wdx-icon
                                            [icon]="
                                                icon.icon +
                                                ' fa-2x fa-stack-1x ' +
                                                icon.style
                                            "
                                            [rotate]="icon?.rotate"
                                            [offsetTop]="icon?.offsetTop"
                                            [offsetLeft]="icon?.offsetLeft"
                                            [scale]="icon?.scale"
                                        ></wdx-icon>
                                    }
                                </wdx-icon-stack>
                            }

                            @if (option.icon) {
                                <wdx-icon
                                    icon
                                    [icon]="option.icon + ' fa-2x'"
                                ></wdx-icon>
                            }
                        </wdx-checkbox-tile>
                    }
                </wdx-checkbox-tile-group>
            }
        </wdx-form-field>
    </ng-container>
}
